// Account helpers: upgrade an anonymous guest into a permanent Google
// account without losing their uid (and therefore their ratings).
import {
  GoogleAuthProvider,
  linkWithPopup,
  signInWithPopup,
  signInWithCredential,
  signOut,
} from 'firebase/auth';
import { auth } from './firebase';

// Links the current anonymous user to Google, keeping the same uid so their
// existing rating documents stay owned by them. Falls back gracefully if the
// Google account is already a permanent account elsewhere.
export async function linkGoogle() {
  const provider = new GoogleAuthProvider();
  const user = auth.currentUser;

  // No session at all — just sign in normally.
  if (!user) {
    return signInWithPopup(auth, provider);
  }

  try {
    return await linkWithPopup(user, provider);
  } catch (err) {
    if (err.code === 'auth/credential-already-in-use') {
      // This Google account already exists as its own account; sign into it
      // instead of linking. (Ratings left under the previous anonymous id
      // remain under that id.)
      const credential = GoogleAuthProvider.credentialFromError(err);
      if (credential) return signInWithCredential(auth, credential);
    }
    throw err;
  }
}

export function signOutUser() {
  return signOut(auth);
}
